var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVDbl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.330946 4.91428C0.330503 4.99105 0.345217 5.06715 0.374247 5.13822C0.403276 5.2093 0.446049 5.27394 0.500113 5.32845L4.00011 8.82845C4.10996 8.93829 4.25894 9 4.41428 9C4.56962 9 4.7186 8.93829 4.82845 8.82845C4.93829 8.7186 5 8.56962 5 8.41428C5 8.25894 4.93829 8.10996 4.82845 8.00011L1.73678 4.91428L4.82261 1.82845C4.91818 1.71685 4.96812 1.57331 4.96244 1.4265C4.95677 1.27969 4.89591 1.14042 4.79202 1.03653C4.68814 0.932646 4.54887 0.871786 4.40206 0.866115C4.25525 0.860444 4.11171 0.91038 4.00011 1.00595L0.500113 4.50595C0.392345 4.6146 0.331591 4.76125 0.330946 4.91428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48141 4.92101C3.48108 4.97887 3.49217 5.03622 3.51405 5.08978C3.53592 5.14334 3.56816 5.19205 3.6089 5.23313L6.24649 7.87072C6.32927 7.9535 6.44154 8 6.5586 8C6.67567 8 6.78794 7.9535 6.87072 7.87072C6.9535 7.78794 7 7.67567 7 7.5586C7 7.44154 6.9535 7.32927 6.87072 7.24649L4.54085 4.92101L6.86632 2.59554C6.93834 2.51144 6.97597 2.40327 6.9717 2.29263C6.96743 2.18199 6.92156 2.07705 6.84327 1.99876C6.76498 1.92046 6.66003 1.8746 6.54939 1.87033C6.43876 1.86605 6.33058 1.90369 6.24649 1.9757L3.6089 4.61329C3.52768 4.69517 3.4819 4.80569 3.48141 4.92101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVDbl);
export default __webpack_public_path__ + "static/media/v_dbl.245dd91c168e1989b910748b039ea9ce.svg";
export { ForwardRef as ReactComponent };